import * as React from 'react';
import { actions } from 'react-redux-form';
import * as moment from 'moment';
import * as deepEqual from 'deep-equal';
import { pick, assign, merge, map, partialRight } from 'lodash';
import { Card, Form } from '../';
import BookingChargeList from '../Bookings/BookingChargeList';

interface Booking {
  return_date?: string;
  mileage_before?: number;
  mileage_after?: number;
  additional_charges?: Array<any>;
  zero_rated_charges?: Array<any>;
}

interface Props {
  handleChange: Function;
  handleChargesUpdate: Function;
  booking: Booking;
}

interface State {
  booking?: Booking;
}

class BookingFinalForm extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      booking: assign(
        {},
        pick(this.props.booking, [
          'additional_charges',
          'zero_rated_charges',
          'mileage_before',
          'mileage_after',
        ]),
      ),
    };
    this.handleUpdate = this.handleUpdate.bind(this);
  }

  /**
   * Handle forms updating if they have changed
   */
  handleUpdate(data) {
    const booking = merge({}, this.state.booking, data);

    const propsBooking: Booking = {
      mileage_before: this.props.booking.mileage_before,
    };

    if (this.props.booking.mileage_after) {
      propsBooking.mileage_after = this.props.booking.mileage_after;
    }

    if (data.return_date && data.return_time) {
      booking.return_date = `${data.return_date} ${data.return_time}:00`;
      this.setState({
        booking,
      });

      propsBooking.return_date = moment(this.props.booking.return_date).format(
        'YYYY-MM-DD HH:mm:00',
      );
    }

    if (
      !deepEqual(
        propsBooking,
        pick(booking, ['return_date', 'mileage_before', 'mileage_after']),
      )
    ) {
      this.props.handleChange(booking);
    }
  }

  /**
   * Check if a charge list has been updated
   */
  isChargeUpdated(chargeChange, comparisonField): boolean {
    const chargeFields = ['id', 'amount', 'description'];

    // Map out the charges to the fields to compare against
    const mapCharges = (charges) =>
      map(charges, partialRight(pick, chargeFields));

    return !deepEqual(mapCharges(chargeChange), mapCharges(comparisonField));
  }

  render() {
    return (
      <Card>
        <div className="field">
          <Form
            type="finalFormFirst"
            hasButton={false}
            fields={[
              { label: 'Return Date', name: 'return_date', type: 'date' },
              { label: 'Return Time', name: 'return_time', type: 'time' },
            ]}
            getDispatch={(dispatch) => {
              dispatch(
                actions.change(
                  'finalFormFirst.return_date',
                  moment(this.props.booking.return_date).format('YYYY-MM-DD'),
                ),
              );
              dispatch(
                actions.change(
                  'finalFormFirst.return_time',
                  moment(this.props.booking.return_date).format('HH:mm'),
                ),
              );
            }}
            handleChange={this.handleUpdate}
          />
        </div>
        <div className="field">
          <Form
            type="finalFormSecond"
            hasButton={false}
            disabled
            fields={[
              {
                label: 'Mileage Before',
                name: 'mileage_before',
                type: 'number',
              },
            ]}
            getDispatch={(dispatch) => {
              dispatch(
                actions.change(
                  'finalFormSecond.mileage_before',
                  this.props.booking.mileage_before,
                ),
              );
            }}
          />
        </div>
        <div className="field">
          <Form
            type="finalFormThird"
            hasButton={false}
            fields={[
              { label: 'Mileage After', name: 'mileage_after', type: 'number' },
            ]}
            getDispatch={(dispatch) => {
              dispatch(
                actions.change(
                  'finalFormThird.mileage_after',
                  this.props.booking.mileage_after,
                ),
              );
            }}
            handleChange={this.handleUpdate}
          />
        </div>
        <div className="field">
          <BookingChargeList
            booking={this.state.booking}
            title="Additional Charges"
            charges={this.state.booking.additional_charges}
            handleChange={(additionalCharges) => {
              if (
                this.isChargeUpdated(
                  additionalCharges,
                  this.state.booking.additional_charges,
                )
              ) {
                this.props.handleChargesUpdate(additionalCharges, undefined);
              }
            }}
          />
          <BookingChargeList
            booking={this.state.booking}
            title="Zero Rated Charges"
            charges={this.state.booking.zero_rated_charges}
            handleChange={(vehicleCharges) => {
              if (
                this.isChargeUpdated(
                  vehicleCharges,
                  this.state.booking.zero_rated_charges,
                )
              ) {
                this.props.handleChargesUpdate(undefined, vehicleCharges);
              }
            }}
          />
        </div>
      </Card>
    );
  }
}

export default BookingFinalForm;
